<p-dialog
  header="Nuevo Ticket"
  [visible]="visible()"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [maximizable]="true"
  [style]="{ width: '860px' }"
  [breakpoints]="{ '960px': '90vw', '640px': '95vw' }"
  (onShow)="onShow()"
>
  <div class="flex flex-col gap-4 pt-2">
    <!-- Título -->
    <div class="flex flex-col gap-1">
      <label class="text-sm font-medium" for="form-titleInput">Título <span class="text-red-500">*</span></label>
      <input
        id="form-titleInput"
        pInputText
        [ngModel]="title()"
        (ngModelChange)="title.set($event)"
        placeholder="Describe el problema brevemente..."
        class="w-full"
      />
    </div>

    <!-- Tipo y Prioridad -->
    <div class="grid grid-cols-2 gap-4">
      <div class="flex flex-col gap-1">
        <label id="form-typeSelect-label" class="text-sm font-medium" for="form-typeSelect">Tipo</label>
        <p-select
          ariaLabelledBy="form-typeSelect-label"
          inputId="form-typeSelect"
          [options]="typeOptions"
          [ngModel]="type()"
          (ngModelChange)="type.set($event)"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          class="w-full"
        />
      </div>
      <div class="flex flex-col gap-1">
        <label id="form-prioritySelect-label" class="text-sm font-medium" for="form-prioritySelect">Prioridad</label>
        <p-select
          ariaLabelledBy="form-prioritySelect-label"
          inputId="form-prioritySelect"
          [options]="priorityOptions"
          [ngModel]="priority()"
          (ngModelChange)="priority.set($event)"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          class="w-full"
        />
      </div>
    </div>

    <!-- Descripción con editor enriquecido -->
    <div class="flex flex-col gap-1">
      <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -- p-editor renderiza Quill (contenteditable), no es un elemento labelable por HTML spec; se usa aria-labelledby -->
      <label id="form-descLabel" class="text-sm font-medium"> Descripción <span class="text-red-500">*</span> </label>
      <p-editor
        aria-labelledby="form-descLabel"
        [ngModel]="description()"
        (ngModelChange)="description.set($event)"
        (onInit)="onEditorInit($event)"
        [style]="{ height: '220px' }"
        placeholder="Detalla el problema, pasos para reproducirlo, comportamiento esperado..."
      >
        <ng-template #header>
          <span class="ql-formats">
            <select class="ql-header">
              <option value="1">Título 1</option>
              <option value="2">Título 2</option>
              <option selected>Normal</option>
            </select>
          </span>
          <span class="ql-formats">
            <button class="ql-bold" title="Negrita"></button>
            <button class="ql-italic" title="Cursiva"></button>
            <button class="ql-underline" title="Subrayado"></button>
            <button class="ql-strike" title="Tachado"></button>
          </span>
          <span class="ql-formats">
            <button class="ql-list" value="ordered" title="Lista numerada"></button>
            <button class="ql-list" value="bullet" title="Lista de puntos"></button>
          </span>
          <span class="ql-formats">
            <button class="ql-blockquote" title="Cita"></button>
            <button class="ql-code-block" title="Bloque de código"></button>
          </span>
          <span class="ql-formats">
            <button class="ql-link" title="Enlace"></button>
            <button class="ql-image" title="Imagen"></button>
            <button class="ql-clean" title="Limpiar formato"></button>
          </span>
        </ng-template>
      </p-editor>
      <!-- Contador de límites (peso / imágenes / texto) -->
      <div class="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-surface-500">
        <span [class.text-red-500]="stats().bytes > limits.maxBytes">
          Peso: {{ formatBytes(stats().bytes) }} / {{ formatBytes(limits.maxBytes) }}
        </span>
        <span [class.text-red-500]="stats().imageCount > limits.maxImages">
          Imágenes: {{ stats().imageCount }} / {{ limits.maxImages }}
        </span>
        <span [class.text-red-500]="stats().textLength > limits.maxTextLength">
          Texto: {{ stats().textLength }} / {{ limits.maxTextLength }}
        </span>
      </div>
      @if (limitErrors().length) {
        <ul class="text-xs text-red-500 list-disc pl-5">
          @for (err of limitErrors(); track err) {
            <li>{{ err }}</li>
          }
        </ul>
      }
    </div>

    <!-- Etiquetas -->
    @if (tags().length) {
      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium" for="form-tagsSelect">Etiquetas</label>
        <p-multiselect
          inputId="form-tagsSelect"
          [options]="tags()"
          [ngModel]="selectedTagIds()"
          (ngModelChange)="selectedTagIds.set($event)"
          optionLabel="name"
          optionValue="id"
          placeholder="Seleccionar etiquetas..."
          appendTo="body"
          class="w-full"
        />
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Cancelar" severity="secondary" (onClick)="close()" [disabled]="isSaving()" />
    <p-button label="Crear Ticket" [loading]="isSaving()" [disabled]="!isValid()" (onClick)="save()" />
  </ng-template>
</p-dialog>
